import { StylesChargeOptionsHeader } from '../styles';

const ChargeOptionsHeader = () => {
    return (
        <StylesChargeOptionsHeader>
            <span>Code</span>
            <span>Description</span>
            <span>Nominal</span>
            <span>Tax</span>
        </StylesChargeOptionsHeader>
    );
};

export default ChargeOptionsHeader;
